module.exports = __webpack_public_path__ + "static/media/logo_qualdo-mqx-light.08621011.svg";